import { render } from "./NotificationsResult.vue?vue&type=template&id=5fdab5ac&scoped=true"
import script from "./NotificationsResult.vue?vue&type=script&lang=js"
export * from "./NotificationsResult.vue?vue&type=script&lang=js"

import "./NotificationsResult.vue?vue&type=style&index=0&id=5fdab5ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdab5ac"]])

export default __exports__